import React from 'react';

import { Button } from '@vtblife/uikit';

import classname from '@search/classname/src';

import './styles.css';

const cn = classname.bind(null, 'QuizBuilderStepButtons');

const MAIN_BUTTON_WIDTH = 296;
const SECONDARY_BUTTON_WIDTH = 100;
const MOBILE_SECONDARY_BUTTON_WIDTH = 52;

const QuizBuilderStepButtons = ({ currentStepNumber, goToNextStep, goToPrevStep, totalSteps, isMobile }: {
    currentStepNumber: number;
    totalSteps: number;
    goToNextStep: () => void;
    goToPrevStep: () => void;
    isMobile?: boolean;
}) => {
    if (currentStepNumber === 1) {
        return (
            <Button
                fullWidth={isMobile}
                width={isMobile ? undefined : MAIN_BUTTON_WIDTH}
                onClick={goToNextStep}
            >
                Начать тест
            </Button>
        );
    }

    return (
        <>
            <div className={cn('button-prev')}>
                <Button
                    variant='secondary'
                    width={isMobile ? MOBILE_SECONDARY_BUTTON_WIDTH : SECONDARY_BUTTON_WIDTH}
                    icon={isMobile ? 'arrow-left' : undefined}
                    onClick={goToPrevStep}
                >
                    {isMobile ? undefined : 'Назад'}
                </Button>
            </div>
            {
                currentStepNumber === totalSteps ? (
                    <Button
                        fullWidth={isMobile}
                        width={isMobile ? undefined : MAIN_BUTTON_WIDTH}
                        onClick={goToNextStep}
                    >
                        Завершить тест
                    </Button>
                ) : (
                    <Button
                        fullWidth={isMobile}
                        width={isMobile ? undefined : MAIN_BUTTON_WIDTH}
                        onClick={goToNextStep}
                    >
                        Следующий вопрос
                    </Button>
                )
            }
        </>
    );
};

export default QuizBuilderStepButtons;
